import React from 'react';
import { UiKit } from '@datavant/uikit';
import { VStack } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const AthenaModal = (props: { onClose: () => void; isOpen: boolean }) => {
    const onClick = () => {
        const url = 'https://marketplace.athenahealth.com/authorization-consent?product=healthsource';
        window.open(url, '_blank');
    };

    const ModalBody = (
        <VStack width={'100%'} alignItems={'left'} spacing={UiKit.consistency.extraLargeBuffer}>
            <UiKit.Text.BodyRegularBold>
                To continue AutoFulfill set up, please complete the Athena Authorization & Consent form using
                the button below.
            </UiKit.Text.BodyRegularBold>
            <UiKit.Text.BodyRegular>
                Note: The form requires an athenahealth practice ID. To locate the practice ID, log into
                athenaNet and click on your username in the upper right-hand corner. You will see the practice
                name with a number in parentheses next to it. The practice ID is the number in the
                parentheses.
            </UiKit.Text.BodyRegular>
        </VStack>
    );

    const ModalFooter = (
        <UiKit.Chakra.VStack>
            <UiKit.Chakra.HStack w={'full'} justifyContent={'flex-end'} spacing={UiKit.consistency.buffer}>
                <UiKit.Button.Cancel text={'Not Now'} onClick={props.onClose} />
                <UiKit.Button.Primary
                    text="Complete Form"
                    onClick={onClick}
                    rightIcon={<FontAwesomeIcon icon={UiKit.Icons.FontAwesome.solid.faArrowRight} />}
                />
            </UiKit.Chakra.HStack>
        </UiKit.Chakra.VStack>
    );

    return (
        <UiKit.Modal
            title={'Continue Autofulfill Set Up'}
            bodyFragment={ModalBody}
            footerFragment={ModalFooter}
            onClose={props.onClose}
            isOpen={props.isOpen}
            size={'2xl'}
            fullScreen={false}
        />
    );
};
